import { useTranslation } from 'react-i18next';
import { isEmployeeWorkspaceEnabled } from '../../utils/featureFlags';

export default function WorkspaceFeatureRoute({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();

  if (!isEmployeeWorkspaceEnabled()) {
    return (
      <div className="max-w-lg mx-auto mt-16 p-8 bg-surface-0 rounded-xl shadow-xs border border-surface-200 text-center">
        <p className="text-lg font-semibold text-surface-800 mb-2">{t('workspace.disabled.title')}</p>
        <p className="text-sm text-surface-500">{t('workspace.disabled.description')}</p>
      </div>
    );
  }

  return <>{children}</>;
}
